import { createSlice } from "@reduxjs/toolkit";

const eventSlice = createSlice({
    name: 'events',
    initialState: {
        events: [
            
        ]
    },

    reducers: {
        updateEvents : (state, action) => {
            state.events = action.payload
        }
    }
});

export const {updateEvents} = eventSlice.actions;
export default eventSlice.reducer;